module.exports = __webpack_public_path__ + "static/img/icon_code_gzh.0798eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/icon_code_gzh.jpg
// module id = kgCs
// module chunks = 49